import { render, staticRenderFns } from "./FacultyCard.vue?vue&type=template&id=5a6bbc0f"
import script from "./FacultyCard.vue?vue&type=script&lang=js"
export * from "./FacultyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\MDA\\schoolofmusic-ucla\\web\\app\\themes\\ucla\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a6bbc0f')) {
      api.createRecord('5a6bbc0f', component.options)
    } else {
      api.reload('5a6bbc0f', component.options)
    }
    module.hot.accept("./FacultyCard.vue?vue&type=template&id=5a6bbc0f", function () {
      api.rerender('5a6bbc0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/components/FacultyCard.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/FacultyCard.vue
// module id = 399
// module chunks = 0